import type { WallpaperConfig } from '../config/schema';
import { lifeGridDimensions, parseISODate, unitsLived } from '../lib/dates';

interface Props {
  config: WallpaperConfig;
  today: Date;
  configUrl: string;
  rawText: string | null;
}

export function DebugPanel({ config, today, configUrl, rawText }: Props) {
  const { rows, cols } = lifeGridDimensions(config.life.unit, config.life.lifeExpectancy);
  const lived = unitsLived(parseISODate(config.life.birthDate), today, config.life.unit);

  return (
    <div className="fixed top-4 right-4 max-w-md max-h-[90vh] overflow-auto rounded bg-zinc-900/90 backdrop-blur p-4 text-xs font-mono text-zinc-200 ring-1 ring-zinc-700 z-50">
      <div className="font-bold text-sm mb-2 text-zinc-100">debug</div>
      <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1">
        <span className="text-zinc-400">today</span>
        <span>{today.toISOString().slice(0, 10)}</span>
        <span className="text-zinc-400">mode</span>
        <span>{config.mode}</span>
        <span className="text-zinc-400">device</span>
        <span>{config.device.width}×{config.device.height}</span>
        <span className="text-zinc-400">life grid</span>
        <span>{rows} rows × {cols} cols ({config.life.unit})</span>
        <span className="text-zinc-400">lived</span>
        <span>{lived} {config.life.unit}</span>
        <span className="text-zinc-400">config url</span>
        <span className="break-all">{configUrl}</span>
      </div>
      <details className="mt-3">
        <summary className="cursor-pointer text-zinc-400">parsed config</summary>
        <pre className="mt-2 whitespace-pre-wrap break-all">{JSON.stringify(config, null, 2)}</pre>
      </details>
      {rawText && (
        <details className="mt-2">
          <summary className="cursor-pointer text-zinc-400">raw yaml</summary>
          <pre className="mt-2 whitespace-pre-wrap break-all">{rawText}</pre>
        </details>
      )}
    </div>
  );
}
